export type ConsentStatus = 'APPROVED' | 'PENDING' | 'ABSENT';

export const CONSENT_STATUS = {
    APPROVED: 'APPROVED' as ConsentStatus,
    PENDING: 'PENDING' as ConsentStatus,
    ABSENT: 'ABSENT' as ConsentStatus,
};

export type SubscriptionsResponse = { daily: boolean; weekly: boolean };

export type ConsentResponse = {
    status: ConsentStatus;
};
